export class StatisticsUserModel {
    constructor(
        public firstname: string,
        public lastname: string,
        public id: string,
        public isCheckedIn: boolean,
        public show: boolean
    ) { }
}
